import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetsPipe } from '@pipes/assets.pipe';

import { User } from '../../../models/Core/User';
import { ConfigService } from '../../../services/config.service';
import { DirectMsgComponent } from '../../account/direct-msg/direct-msg.component';

@Component({
  selector: 'app-selected-user',
  templateUrl: './selected-user.component.html',
  styleUrls: ['./selected-user.component.scss'],
})
export class SelectedUserComponent {
  @Input() user: User;
  @Input() currentIndex: number;
  @Input() totalNumberOfUsers: number;

  constructor(
    private modal: NgbModal,
    private appConfig: ConfigService,
    private assetsPipe: AssetsPipe,
  ) {}

  get profilePicUrl() {
    const _default = 'image/default_profile_picture.png';
    return this.assetsPipe.transform(
      this.user ? this.user.profile_picture || _default : _default,
    );
  }

  get hasContactInfo() {
    return this.user && (this.user.email || this.hasLocation);
  }

  get hasLocation() {
    return (
      this.user &&
      this.user.location &&
      (this.user.location.city ||
        this.user.location.country ||
        this.user.location.zipcode)
    );
  }

  get hasEmail() {
    return (
      this.user &&
      this.user.email &&
      this.user.visibility &&
      this.user.visibility.email
    );
  }

  get hasDepartment() {
    return (
      this.user &&
      this.user.department &&
      this.user.visibility &&
      this.user.visibility.department
    );
  }

  get hasOccupation() {
    return (
      this.user &&
      this.user.department &&
      this.user.visibility &&
      this.user.visibility.occupation
    );
  }

  directMsg() {
    const ref = this.modal.open(DirectMsgComponent);
    ref.componentInstance.user = this.user;
  }
}
